import React from 'react';
import Loadable from 'react-loadable';
import LoadableLoading from 'components/LoadableLoading';
import { getContragentBadAddAvailableColumns } from './api';

export const path = '/contragent-bad/add/list';

const PageContragentBadAdd: React.FC = (props) => {
  const ContragentBadAdd = Loadable.Map({
    loader: {
      page: () => import('./page'),
      columns: getContragentBadAddAvailableColumns,
    },
    loading: LoadableLoading,
    render(loaded, loadedProps) {
      const Page = loaded.page.default;

      return <Page {...loadedProps} {...loaded} columns={loaded.columns} />;
    },
  });

  return <ContragentBadAdd {...props} />;
};

export default PageContragentBadAdd;
